function base64URLencode(str: string) {
  const base64Encoded = btoa(str)
  return base64Encoded
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "")
}

export async function generateHash(message: string) {
  const encoder = new TextEncoder()
  const data = encoder.encode(message)
  const hash = await crypto.subtle.digest("SHA-256", data)

  const sha256 = Array.from(new Uint8Array(hash), (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("")

  const base64encoded = base64URLencode(sha256)
  const checksumId = base64encoded.slice(0, 32)

  return checksumId
}
